import { deleteIcon } from 'assets/icons'
import { logoutImg } from 'assets/images'
import { Button, LoadingButton } from 'components/form'
import CustomModal from 'components/modals/CustomModal'
import { getToken, removeToken } from 'config/axiosInstance'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { clearSelectedSite } from 'redux-toolkit/slices/selectedSiteSlice'
import { resetUserProfile } from 'redux-toolkit/slices/userProfileSlice'
import { logoutApi } from 'services/auth'
import { deleteAccountApi } from 'services/profile'
import { failMessage, successMessage } from 'utils/toastMessage'
const LogOut = ({ show, close }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()
  const dispatch = useDispatch();
  //---------send-otp-handler-----------------
  const logoutHandler = async () => {
    try {
      const token = getToken()
      setLoading(true);
      const res = await logoutApi();
      if (res?.status === 200) {
        successMessage(res)
        close()
        removeToken()
        navigate('/')
        // After successful logout clear both data:
        dispatch(resetUserProfile());
        dispatch(clearSelectedSite());
      } else {
        failMessage(res)
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <CustomModal
      show={show}
      handleClose={close}
      className={"logoutModal"}
      closeButton={false}
    >
      <div className="wrap_log_modal">
        <div className="icons">
          <img src={logoutImg} alt="" />
        </div>
        <h3>Do you want to logout from this device?</h3>

        <div className="button_wrap button_center">
          <LoadingButton
            className={"light"}
            loading={loading}
            onClick={logoutHandler}
          >
            Yes
          </LoadingButton>
          <Button onClick={close}>No</Button>
        </div>
      </div>
    </CustomModal>
  )
}

export default LogOut



//-----------Delete-Account---------------

export const DeleteAccount = ({ show, close }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()
  //---------send-otp-handler-----------------
  const deleteAccount = async () => {
    try {
      const token = getToken()
      setLoading(true);
      const res = await deleteAccountApi();
      if (res?.status === 200) {
        successMessage(res)
        close()
        removeToken()
        navigate('/')
      } else {
        failMessage(res)
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <CustomModal
      show={show}
      handleClose={close}
      className={"logoutModal"}
      closeButton={false}
    >
      <div className="wrap_log_modal">
        <div className="icons">
          <img src={deleteIcon} alt="" />
        </div>
        <h3>Do you want to delete your account?</h3>

        <div className="button_wrap button_center">
          <LoadingButton
            className={"light"}
            loading={loading}
            onClick={deleteAccount}
          >
            Yes
          </LoadingButton>
          <Button onClick={close}>No</Button>
        </div>
      </div>
    </CustomModal>
  )
}

